module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success"
  }, [_c('h3', {
    staticClass: "success__title"
  }, [_vm._v("Запрос успешно отправлен")]), _c('div', {
    staticClass: "success__buttons"
  }, [_c('Button', {
    attrs: {
      "bordered": true
    },
    on: {
      "click": function($event) {
        return _vm.$emit('backToForm')
      }
    }
  }, [_vm._v("Вернуться к форме")]), _c('Button', {
    attrs: {
      "bordered": true
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toAllRequest')
      }
    }
  }, [_vm._v("Перейти в запросы")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-123cc571","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/succss/MentoringSuccess.vue
// module id = 274d5676e606c5513a14
// module chunks = 89